export enum SenderType {
  Cliente = 0,
  Analista = 1,
  Sistema = 2,
}

export enum MessageType {
  Texto = 0,
  Arquivo = 1,
}

export interface SolicitationMessage {
  id: number;
  callcode: string;
  senderType: SenderType;
  senderId: string;
  senderDisplayName: string;
  messageType: MessageType;
  text?: string | null;
  fileName?: string | null;
  fileType?: string | null;
  fileUrl?: string | null;
  createdAt: string;
  readByClientAt?: string | null;
  readByAnalystAt?: string | null;
}

export interface SendSolicitationMessageRequest {
  callcode: string;
  text?: string | null;
  fileName?: string | null;
  fileType?: string | null;
  fileUrl?: string | null;
}

export interface UnreadCount {
  callCode: string;
  messageCount: number;
}
